import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CheckboxTableManual from "components/Common/CheckboxTableManual/CheckboxTableManual";
import { Button } from "react-bootstrap";
import { loadCompanyCreateEnterpriseStart } from "services/redux/actions/serviceDesk";
import ActualTimezoneDate from "components/Common/ActualTimezoneDate";
import TimezoneDate from "components/Common/TimezoneDate.js";

import _ from "lodash";

class DataTable extends React.Component {
  state = {
    previousDataTableState: {
      page: 0,
      pageSize: 20,
    },
  };
  
  componentDidMount = () => {
    const { companyId, loadingCompanyCreateEnterpriseSites } = this.props;
    if (loadingCompanyCreateEnterpriseSites === null) {
      this.props.dispatch(loadCompanyCreateEnterpriseStart({ company_id: companyId }));
    }
  }

  componentDidUpdate = (prevProps) => {
    const { selectAll, handleSelectAll, externalFilters } = this.props;

    if (selectAll) {
      if (!_.isEqual(prevProps.externalFilters, externalFilters)) {
        // with server side pagination and when select all is ticked, i.e. when we're tracking exclusions rather than selections,
        // we can't make an accurate calculation of how many and which items have been selected when the filters change.
        // the safest thing to do is to clear the selections (i.e. exclusions)
        handleSelectAll();
      }
    }
  }

  toggleAll = () => {
    const { handleSelectAll } = this.props;
    handleSelectAll();
  };

  deselect = () => {
    const { handleSelection, selectAll } = this.props;
    handleSelection([]);
    if (selectAll) {
      this.toggleAll();
    }
  };

  applyTableFilter = (filterValue, filterColumnDetails, columns) => {
    const {
      tableFilters,
      updateTableFilters,
      handleSelectAll,
    } = this.props;

    // re-construct the list of filters and incorporate the incoming new filter
    const newTableFilters = columns
      // start by looping through all the columns we have
      .map((column) => {
        // for each column, find any existing filter that is currently being applied to that column
        // from our list of current filters (tableFilters)
        const existingFilter = _.find(tableFilters, {"id": column.id});

        if (column.id === filterColumnDetails.id) {
          // if the id of the current column we're looping through matches the id of the incoming filtered column,
          // then we know that this is the one that's being changed
          return {
            id: column.id,
            value: filterValue,
            header: filterColumnDetails.Header,
            color: filterColumnDetails.filterTagColor ? filterColumnDetails.filterTagColor : "#191970",
          };
        } else if (existingFilter) {
          // if the id of the current column we're looping through does not match the id of the incoming filtered column,
          // but we do have an existing filter for that column, just return the filter unchanged
          return existingFilter;
        } else {
          // if the id of the current column we're looping through does not match the id of the incoming filtered column,
          // and also we do not have any existing filter, return an empty value, which can then be filtered out of the array
          return { value: "" };
        }
      })
      .filter((item) => {
        // filter the empty values out of the array
        return !!item.value;
      });

    // update the list used by the table component
    updateTableFilters(newTableFilters);

    if (this.props.selectAll) {
      // with server side pagination and when select all is ticked, i.e. when we're tracking exclusions rather than selections,
      // we can't make an accurate calculation of how many and which items have been selected when the filters change.
      // the safest thing to do is to clear the selections (i.e. exclusions)
      handleSelectAll();
    }
  }

  render() {
    const { 
      companyId,
      companyType,
      sudoSites,
      customFields,
      pagination,
      tableFilters,
      externalFilters,
      handler,
    } = this.props;

    let noDataMsg = "No data available...";

    const columns = [
      {
        key: "ID",
        Header: "Id",
        id: "id",
        width: 60,
        show: false,
        accessor: data => data.id,
      },
      {
        key: "SITE_REF",
        Header: "Site Ref",
        id: "site_ref",
        width: 80,
        // filterTagColor: FILTER_TAG_COLOURS["site_ref"],
        accessor: data => data.site_ref,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "TRANSMITTER_REF",
        Header: "Transmitter Ref",
        id: "transmitter_ref",
        width: 120,
        // filterTagColor: FILTER_TAG_COLOURS["transmitter_ref"],
        accessor: data => data.transmitter_ref,
        Filter: ({ column }) => {
          return (
              <input
                type="text"
                id={`${column.id}_filter_input`}
                onChange={_.debounce((e) => {
                  this.applyTableFilter(e.target.value, column, columns);
                }, 300)}
              />
            )
        }
      },
      {
        key: "COMPANY",
        Header: "Site Name",
        id: "company",
        minWidth: 150,
        accessor: data => data.company,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "ENTERPRISES",
        Header: "Enterprises",
        id: "enterprises",
        minWidth: 310,
        accessor: data => data.enterprises,
        filterable: false,
        Cell: ({row}) => {
          return <div>
            {
              row.enterprises.map((enterprise, index) => {
                return <span key={index} className="mx-1">
                  {/* <Tooltip
                    placement="left"
                    description="Go to Enterprise"
                  > */}
                    <Button
                      variant="primary"
                      disabled
                      onClick={() => {
                        return;
                        // this.props.history.push(`/enterprise/${enterprise.id}`);
                      }}
                    >
                      {enterprise.name}
                    </Button>
                  {/* </Tooltip> */}
                </span>
              })
            }
          </div>
        }
      },
      {
        key: "ADDRESS_1",
        Header: "Address 1",
        id: "address1",
        width: 115,
        accessor: data => data.address1,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "ADDRESS_2",
        Header: "Address 2",
        id: "address2",
        width: 115,
        accessor: data => data.address2,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "TOWN",
        Header: "Town",
        id: "town",
        width: 115,
        accessor: data => data.town,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "COUNTRY",
        Header: "Country",
        id: "country",
        width: 80,
        // filterTagColor: FILTER_TAG_COLOURS["country"],
        className: "text-center",
        // accessor: data => countryList().getLabel(data.country),
        accessor: data => data.country,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "POSTCODE",
        Header: "Postcode",
        id: "postcode",
        width: 90,
        accessor: data => data.postcode,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: companyType === "A" ? "INSTALLER" : "ARC",
        Header: companyType === "A" ? "Installer" : "ARC",
        id: companyType === "A" ? "installer" : "arc",
        width: 90,
        accessor: data => companyType === "A" ? data.installer.name : data.arcmap.name,
        filterable: false,
        show: !!companyType
      },
      {
        key: "CONTRACT_NUMBER",
        Header: "Contract Number",
        id: "contract_number",
        width: 130,
        // filterTagColor: FILTER_TAG_COLOURS["contract_number"],
        accessor: data => data.contract_number,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
      {
        key: "PRODUCT_DESCRIPTION",
        Header: "Product Description",
        id: "product_description",
        width: 150,
        // filterTagColor: FILTER_TAG_COLOURS["product_description"],
        accessor: data => data.product_description,
        Filter: ({ column }) => {
          return <input
            type="text"
            id={`${column.id}_filter_input`}
            onChange={_.debounce((e) => {
              this.applyTableFilter(e.target.value, column, columns);
            }, 300)}
          />
        }
      },
    ];

    if (customFields) {
      const fields = Object.keys(customFields);
      if (fields.length >= 1) {
        // const customTagColours = FILTER_TAG_COLOURS["custom"];
        fields.forEach((field, index) => {
          // let tagColorIndex = index;
          // while (tagColorIndex >= customTagColours.length) {
          //   tagColorIndex = tagColorIndex - customTagColours.length;
          // }
          columns.push({
            key: field,
            Header: customFields[field],
            id: field,
            width: 110,
            // filterTagColor: customTagColours[tagColorIndex],
            accessor: data => _.find(data.custom_fields, { 'text_field': field })?.value,
            Filter: ({ column }) => {
              return <input
                type="text"
                id={`${column.id}_filter_input`}
                onChange={_.debounce((e) => {
                  this.applyTableFilter(e.target.value, column, columns);
                }, 300)}
              />
            }
          })
        })
      }
    }

    columns.push(
      {
        key: "LAST_EVENT_ACKED",
        Header: "Last Event Time",
        id: "occurrence",
        minWidth: 160,
        filterable: false,
        accessor: data => {
          const occurrence = {
            acked: data.last_event_acked,
            timezone: data.timezone,
            format: "HH:mm ddd DD/MM/YYYY",
          }
          return occurrence;
        },
        Cell: ({ row }) => {
          const timezone = row.created;
          return <ActualTimezoneDate occurrence={row.occurrence} timezone={timezone} />
        },
      },
      {
        key: "CREATED",
        Header: "Created Date",
        id: "created",
        minWidth: 160,
        filterable: false,
        accessor: data => {
          const created = {
            acked: data.created,
            timezone: data.timezone,
            format: "HH:mm ddd DD/MM/YYYY",
          }
          return created;
        },
        Cell: ({ row }) => {
          const occurrence = row.created;
          return (
            <TimezoneDate
              date={occurrence.acked}
              timezone={occurrence.timezone} 
              format={occurrence.format} 
              hideTimezone={true}
            />
          )
        },
      },
    );

    // const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //   navigator.userAgent
    // );

    return (
      <div>
        {/* CheckboxTableManual - manual mode for server-side pagination */}
        <CheckboxTableManual
          vScroll={'600'}
          columns={columns}
          data={sudoSites}
          noDataText={noDataMsg}
          loadDataAction={loadCompanyCreateEnterpriseStart}
          loadDataParams={{
            company_id: companyId,
            externalFilters: externalFilters,
          }}
          handler={handler}
          pages={pagination.pageCount}
          defaultPageSize={20}
          filterable
          filtered={tableFilters}
          // sortable={sudoSites.length > 0}
          sortable={false}
          keyField="id" // key for the checkbox selections
          className="-striped -highlight"
          allowSelectAll={true}
          // toggleSelection={toggleSelection}              // for the checkbox functionality, EITHER pass a custom toggleSelection function,
          // isSelected={isSelected}                        // and a custom isSelected function,
          // containDetails={true}
          selection={this.props.selection}                                                       // OR pass a selection array,
          setSelection={(selection) => this.props.handleSelection([...selection])}  // and a setter for the array.
          selectAll={this.props.selectAll}                             // for the select all functionality, pass a selectAll flag (show whether select all is checked or not),
          toggleAll={this.toggleAll}                        // and EITHER pass a custom toggleAll function
          // setSelectAll={(selectAll) => this.setState({ selectAll: selectAll })}    // OR pass a setter for the flag
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    // sudoSites: state.serviceDesk.createEnterpriseCompanySites.data.sudoSites,
    customFields: state.serviceDesk.createEnterpriseCompanySites.filterOptions.customFields,
    pagination: state.serviceDesk.createEnterpriseCompanySites.data.pagination,
    loadingCompanyCreateEnterpriseSites: state.serviceDesk.createEnterpriseCompanySites.loadingCompanyCreateEnterpriseSites,
    pageSize: state.serviceDesk.createEnterpriseCompanySites.pageSize,
  };
};
export default withRouter(connect(mapStateToProps)(DataTable));